var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.social=='facebook')?_c('div',{staticClass:"bg-red-50 rounded-full -bottom-1 -right-2",class:_vm.styles},[_c('FacebookIcon')],1):_c('div',{staticClass:"bg-pink-500 rounded-full -bottom-1 -right-2 flex justify-center items-center",class:_vm.styles},[_c('InstagramIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }